import React from "react";

interface Props {
  render?: (x: number, y: number, ratio: { item: any; present: number }) => {};
  posX: number;
  posY: number;
  style?: (x: number, y: number, ratio: number, rowIndex: number) => {};
  ratio: number;
  value: { item: any; present: number };
  height?: string;
  square?: boolean;
  rowIndex: number;
  onClick?: (
    x: number,
    y: number,
    value: { item: any; present: number }
  ) => void;
  onHover?: (
    x: number,
    y: number,
    value: { item: any; present: number }
  ) => void;
}

const noop = (returnVal: any) => () => returnVal;

const Cell: React.FC<Props> = ({
  render = noop(null),
  style = noop({}),
  ratio,
  posX,
  posY,
  square = false,
  height = "2rem",
  value,
  onClick,
  onHover,
  rowIndex,
}) => {
  return (
    <div
      onClick={() => (onClick || noop({}))(posX, posY, value)}
      onMouseOver={() => (onHover || noop({}))(posX, posY, value)}
      style={{
        border: "1px solid #fff",
        borderWidth: "1px 1px 0 0",
        textAlign: "center",
        overflow: "hidden",
        boxSizing: "border-box",
        flexGrow: square ? 0 : 1,
        flexBasis: square ? height : 0,
        flexShrink: 0,
        height: height,
        lineHeight: height,
        borderRadius: "4px",
        fontSize: ".8rem",
        cursor: onClick ? "pointer" : "initial",
        ...style(posX, posY, ratio, rowIndex),
      }}
    >
      {render(posX, posY, value)}
    </div>
  );
};

export default React.memo(Cell);
